import {FC, useEffect} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import FormPayStub from 'components/blocks/forms/FormPayStub/index'
import {klaviyoTrack, posthogTrack} from 'src/utils'

import s from './TemplateCreateDocumentPayStub.module.scss'

const cx = cn.bind(s)

interface ITemplateCreateDocumentPayStubProps {
	className?: string
}

const TemplateCreateDocumentPayStub: FC<ITemplateCreateDocumentPayStubProps> = ({className}) => {
	useEffect(() => {
		posthogTrack('[Paystub] Create paystub page opened')
		klaviyoTrack('Page opened', {page: 'paystub', href: window?.location?.href})
	}, [])
	return (
		<div className={cx('wrapper', className)}>
			<FormPayStub />
		</div>
	)
}

TemplateCreateDocumentPayStub.displayName = 'TemplateCreateDocumentPayStub'

export default observer(TemplateCreateDocumentPayStub)
